import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { patch } from "../../../services/api-services";
import { StyledBlueButton, StyledCancelButton, StyledGreenButton } from "../../StyledComponent";
import { useCommon } from "../../../context/CommonContext";
const EditProgressBar = ({ open, setOpenDialog, weightData, setWeightData, router, openAddWeight, setOpenAddWeight, userData, fetchUserData, weightSuggestion, getCurrentWeight }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { setSnackbar } = useCommon();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setWeightData((prev) => ({ ...prev, [name]: value }))
    };
    const onAddWeight = () => {
        setOpenDialog(false);
        setOpenAddWeight(true);
    }
    const handleSave = async () => {
        try {
            const url = `/Customers/${weightData.customerId}`;
            const userEnteredTarget = weightData.manualTargetWeight === "" || weightData.manualTargetWeight == null
                ? ""
                : Number(weightData.manualTargetWeight);

            const payload = {
                weightGoal: userEnteredTarget,
            };
            await patch(url, payload);

            await fetchUserData()
            setSnackbar({
                openSnackbar: true,
                message: 'Weight goal updated successfully!',
                severity: 'success'
            })
            await getCurrentWeight();
            setOpenDialog(false);
        } catch (error) {
            console.error("Error updating weight goal", error);
            if (error.response?.status === 401) {
                enqueueSnackbar("Login expired. Please log in again.", { variant: "error" });
                localStorage.clear();
                setOpenDialog(false);
                router.navigate("/login");
            }
        }
    };

    return (
        <Dialog open={open} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
            <DialogTitle fontWeight={'bold'}>Weight Goal</DialogTitle>
            <form>
                <DialogContent>
                    {userData?.weight > 0 ? (
                        <>
                            <div>
                                <Typography marginBottom={3} >{weightSuggestion?.weight} Kgs. is the ideal weight for your height.</Typography>
                                <Typography marginBottom={3} color={weightSuggestion?.cases === "Normal" ? 'success' : 'error'}>
                                    You are {weightSuggestion?.cases},
                                    {weightSuggestion?.cases === "Underweight" || weightSuggestion.cases === "Normal"
                                        ? ` You need to gain ${weightSuggestion.loosWeight} Kgs./${weightData?.startWeight} Kgs.`
                                        : ` You need to lose ${weightSuggestion.loosWeight} Kgs./${weightData?.startWeight} Kgs.`}
                                </Typography>
                            </div>

                            <div style={{ display: "flex", gap: "10px" }}>
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    name="manualTargetWeight"
                                    label="Target Weight (In kgs)"
                                    value={weightData.manualTargetWeight || ""}
                                    onChange={handleChange}
                                    helperText={!weightData.manualTargetWeight ? `Leave empty to use system calculated weight (${weightSuggestion?.weight} Kgs)` : ""}
                                />
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    label="BMI"
                                    value={(weightData.manualTargetWeight || weightData.targetWeight) && weightData.height
                                        ? (Number(weightData.manualTargetWeight || weightData.targetWeight) / ((weightData.height / 100) * (weightData.height / 100))).toFixed(2)
                                        : 0}
                                    InputProps={{ readOnly: true }}
                                />
                            </div>
                        </>
                    ) : (
                        <p>Please add your weight!</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <StyledCancelButton onClick={() => setOpenDialog(false)} variant="outlined">
                        CANCEL
                    </StyledCancelButton>
                    <StyledGreenButton onClick={onAddWeight}>
                        ADD WEIGHT
                    </StyledGreenButton>
                    <StyledBlueButton
                        onClick={handleSave}
                        variant="contained"
                        color="primary"
                    >
                        SAVE
                    </StyledBlueButton>
                </DialogActions>
            </form>

        </Dialog>
    );
};

export default EditProgressBar;

